"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ProjectMemberIcon = void 0;
var _sdk = require("../../../sdk");
var _alloyReactIcon = require("@adsk/alloy-react-icon");
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const ProjectMemberIcon = _ref => {
  let {
    memberType,
    ...rest
  } = _ref;
  switch (memberType) {
    case _sdk.ProjectMemberType.Company:
      return /*#__PURE__*/_react.default.createElement(_alloyReactIcon.BuildingFilledIcon, rest);
    case _sdk.ProjectMemberType.Role:
      return /*#__PURE__*/_react.default.createElement(_alloyReactIcon.PeopleFilledIcon, rest);
    case _sdk.ProjectMemberType.User:
      return /*#__PURE__*/_react.default.createElement(_alloyReactIcon.PersonFilledIcon, rest);
    default:
      return null;
  }
};
exports.ProjectMemberIcon = ProjectMemberIcon;
//# sourceMappingURL=ProjectMemberIcon.js.map